import { BASE_URL,  PATCH, REGULATORY_USER_CONSENT} from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";
  
  export const submitUserConsent = async (payload) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${REGULATORY_USER_CONSENT}`;
    return fetch(resource, {
      method: PATCH,
      headers: {
        "Content-Type": "application/json",
        "userauth": `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
      .then(statusParsing)
      .then(jsonParsing);
  };
  